import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { StepperComponent } from '@app/shared/stepper/stepper.component';

@NgModule({
  declarations: [StepperComponent],
  imports: [CommonModule, MatProgressBarModule],
  exports: [StepperComponent],
})
export class StepperModule {}
